import React, { useState } from "react";
import { Modal, Form, Row, Col, Button, Result, message } from 'antd';
import { config } from "util/config";
import { httpClient } from 'util/Api';
import { useHistory } from "react-router-dom";
import * as globalFunction from 'util/GlobalFunction';
import Invoice from "./Invoice";
import Quote from "./Quote";
import ShowResult from "./ShowResult";

const NAB = () => {
  // 公共付款入口统一使用明确的浏览器页签标题。
  document.title = 'Online Payment';

  const history = useHistory();
  let pathname = window.location.pathname.split('/');

  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <NABPage type={pathname[pathname.length - 2]} history={history} />
  )
}
export default NAB;

class NABPage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      loading: true
    }
  }

  showPayPage() {
    switch (this.props.type.toLowerCase()) {
      case 'invoice':
        return <Invoice />
      case 'quote':
        return <Quote />
      case 'callback':
        httpClient
          .get('/Webhooks/NAB' + this.props.history.location.search)
          .then(({ data }) => {
            if (data.result) {
              if (data.data.CheckObject) {
                switch (data.data.Type) {
                  case 'Invoice':
                    window.location.href = '/pay/nab/invoice/' + data.data.Id + '?is_approved=' + data.data.IsApproved + (data.data.Message === null ? '' : '&message=' + data.data.Message);
                    break;
                  case 'Quote':
                    window.location.href = '/pay/nab/quote/' + data.data.Id + '?is_approved=' + data.data.IsApproved + (data.data.Message === null ? '' : '&message=' + data.data.Message);
                    break;
                }
              } else {
                this.setState({ loading: false });
              }
            } else {
              message.error(data.message);
            }
          })
          .catch(function (error) {
            globalFunction.handleError(error, this);
          });
        return <>{this.state.loading ? <></> : <Result
          status='error'
          title='Invalid callback parameter'
        />}</>
    }
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        {this.showPayPage()}
      </div>
    );
  }
};
